/* eslint-disable react/require-default-props,react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import cx from 'classnames';

import Popover from 'material-ui/Popover';
import Menu from '../IconMenu/Menu';

import styles from './index.styl';

const PopoverMenu = ({
  onClose,
  isOpen,
  anchorEl,
  items,
  size,
  style,
  transformOrigin,
  anchorOrigin,
  container,
}) => (
  <Popover
    className="popover"
    open={isOpen}
    anchorEl={anchorEl}
    anchorOrigin={anchorOrigin}
    transformOrigin={transformOrigin}
    container={container}
    {...{ style }}
    {...{ onClose }}
  >
    <div styleName={cx('menu', `menu--${size}`)}>
      <Menu {...{ items }} />
    </div>
  </Popover>
);

PopoverMenu.propTypes = {
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
  items: PropTypes.array,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  transformOrigin: PropTypes.object,
  anchorOrigin: PropTypes.object,
};

PopoverMenu.defaultProps = {
  transformOrigin: { vertical: 'top', horizontal: 'right' },
  anchorOrigin: { horizontal: 'center', vertical: 'bottom' },
};

export default CSSModules(PopoverMenu, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/PopoverMenu/index.jsx